import type { PresenceRow } from '@/types/presence';

export function sortByPresenceThenLabel<T extends { id: string }>(
  items: T[],
  presenceByUserId: Record<string, PresenceRow>,
  labelFor: (item: T) => string
): T[] {
  return [...items].sort((left, right) => {
    const leftOnline = presenceByUserId[left.id]?.is_online ? 1 : 0;
    const rightOnline = presenceByUserId[right.id]?.is_online ? 1 : 0;
    if (leftOnline !== rightOnline) {
      return rightOnline - leftOnline;
    }
    return labelFor(left).localeCompare(labelFor(right), undefined, {
      sensitivity: 'base',
    });
  });
}
